import {IStateHome} from './reducer';
import {
  createAction,
  createActionFetch,
  createBasicActions,
} from '../../../common/util/redux';
import {IMainSecondTab} from '../../main/type';
import {ITimeTableDay} from '../../timeTable/type';
import {HomeTabPage, IEventPopup, INoticePopup, ISecondTabKey} from '../type';

export enum ActionType {
  SetValue = 'home.SetValue',
  SetPropertyValues = 'home.SetPropertyValues',
  ChangeSecondTabSelected = 'home.ChangeSecondTabSelected',
  FetchMessages = 'home.FetchMessages',
  SetMessages = 'home.SetMessages',
  FetchInitializeHome = 'home.FetchInitializeHome',
  InitializeHome = 'home.InitializeHome',
}

export const actions = {
  changeSecondTabSelected: ({
    tabPage,
    selected,
    isTabClick = true,
  }: {
    tabPage: HomeTabPage;
    selected?: ISecondTabKey;
    isTabClick?: boolean;
  }) =>
    createAction(ActionType.ChangeSecondTabSelected, {
      tabPage,
      selected,
      isTabClick,
    }),
  ...createBasicActions<IStateHome>({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
  }),
  fetchMessages: () => createActionFetch(ActionType.FetchMessages),
  setMessages: (data: {
    eventPopupList: IEventPopup[];
    noticePopup?: INoticePopup;
  }) => createAction(ActionType.SetMessages, data),
  fetchInitializeHome: (
    initialTabPage: HomeTabPage,
    initialSecondTab?: string
  ) =>
    createActionFetch(ActionType.FetchInitializeHome, {
      payload: {initialTabPage, initialSecondTab},
    }),
  initializeHome: ({
    initialTabPage,
    initialSecondTab,
    initialMainSecondTab = 'recommend',
    todayWeekday,
  }: {
    initialTabPage: HomeTabPage;
    initialSecondTab?: string;
    initialMainSecondTab?: IMainSecondTab;
    todayWeekday: ITimeTableDay;
  }) =>
    createAction(ActionType.InitializeHome, {
      initialTabPage,
      initialSecondTab,
      initialMainSecondTab,
      todayWeekday,
    }),
};
